import type { PropsWithChildren } from 'react';

import styled from 'styled-components';

type CardProps = {
  isExpanded?: boolean;
};
const CardContainer = ({ children, isExpanded = false }: PropsWithChildren<CardProps>) => {
  return <CardWrapper $isExpanded={isExpanded}>{children}</CardWrapper>;
};

type CardWrapperProps = {
  $isExpanded: boolean;
};

const CardWrapper = styled.article<CardWrapperProps>`
  padding: 40px 56px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.color.line.line_2};
  background-color: ${({ theme }) => theme.color.static.white};
  ${({ $isExpanded }) =>
    $isExpanded &&
    `
      width: 100%;
      flex: 1;
    `}

  @media ${({ theme }) => theme.device.large} {
    padding: 24px 24px;
  }
`;

type CardTitleProps = {
  isExpanded?: boolean;
};
function CardTitle({ children, isExpanded = false }: PropsWithChildren<CardTitleProps>) {
  return <STitle $isExpanded={isExpanded}>{children}</STitle>;
}
type STitleProps = {
  $isExpanded: boolean;
};
const STitle = styled.h2<STitleProps>`
  ${({ theme }) => theme.font.head3_bw};
  height: 48px;
  display: flex;
  align-items: center;

  ${({ $isExpanded }) =>
    $isExpanded &&
    `      
      flex: 1 1 0;
    `};
  @media ${({ theme }) => theme.device.large} {
    ${({ theme }) => theme.font.head5_sb};
  }
`;

function CardHeader({ children }: PropsWithChildren) {
  return <SHeader>{children}</SHeader>;
}

const SHeader = styled.nav``;

function CardBody({ children }: PropsWithChildren) {
  return <SBody>{children}</SBody>;
}

const SBody = styled.div``;

const Card = Object.assign(CardContainer, {
  Title: CardTitle,
  Header: CardHeader,
  Body: CardBody,
});

export default Card;
